
import React from 'react';
import downArrow from './downArrow.svg';
import rightArrow from './rightArrow.svg';
import diamond from './diamond.svg';

import downArrowGreen from './downArrowGreen.svg';
import rightArrowGreen from './rightArrowGreen.svg';
import diamondGreen from './diamondGreen.svg';

import ellipsis from './ellipsis.svg';
import Tooltip from '@material-ui/core/Tooltip';
import zoom from './zoomPlus.svg';
// import drag from './drag.svg';
import task from './task.svg';
import './Element.css';
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { Menu, Item, Separator, Submenu, MenuProvider, contextMenu } from 'react-contexify';
import 'react-contexify/dist/ReactContexify.min.css';


// import { Transition }  from 'react-transition-group';




class Element extends React.Component {

	constructor(props) {
	    super(props);
	    this.state = {text: this.props.text, editMode: false, "indent": props.indent, showOptions: false, showTaskOptions: false};
	    this.handleChange = this.handleChange.bind(this);
	    this.handleKeyDown = this.handleKeyDown.bind(this);
	    this.onFocus = this.onFocus.bind(this);
	    this.onBlur = this.onBlur.bind(this);
	    this.textarea = React.createRef();
	    this.handleBoxClick = this.handleBoxClick.bind(this);
	    this.handleMenuClick = this.handleMenuClick.bind(this);
	    this.handleOptionsMenuClick = this.handleOptionsMenuClick.bind(this);
	    this.handleTaskClick = this.handleTaskClick.bind(this);
  	}


	componentWillUnmount() {
		
	}

	componentDidUpdate(prevProps){

		if (this.props.focus && this.props.focusObjId === this.props.obj.id && prevProps.focusObjId !== this.props.focusObjId) {
			this.textarea.current.focus();
			this.textarea.current.setSelectionRange(this.props.selectionStart,this.props.selectionEnd)
		}
	}

	componentDidMount() {

		if (this.props.focus && this.props.focusObjId === this.props.obj.id) {
			this.textarea.current.focus();
			this.textarea.current.setSelectionRange(this.props.selectionStart,this.props.selectionEnd)
		}

	}

	onFocus(event) {
		
		this.setState({focus: true})
		this.props.setFocus(this.props.obj.id, true, this.textarea.current.selectionStart, this.textarea.current.selectionEnd);
	
	}

	onBlur() {
		this.setState({focus: false})
	}	

	handleBoxClick(event) {
		if (this.props.obj.kids.length > 0) {
			this.props.toggleExpand();
		}
	}

	

	handleChange(event) {
		
		this.setState({text: event.target.value});
		let newObj = {...this.props.obj, t: event.target.value};
		this.props.updateObj(this.props.obj.id, newObj)
		event.target.style.height = 'inherit';
		event.target.style.height = `${event.target.scrollHeight}px`;
	
	}

	handleKeyDown(event) {
		// console.log(event.keyCode, event.metaKey)


		if ( (event.keyCode===9 && !event.shiftKey) || (event.keyCode===221 && event.metaKey)) { // Indent
			// this.setState({indent: this.state.indent + 1})
			this.props.indent();

			event.preventDefault();
		} else if ( (event.keyCode===9 && event.shiftKey) || (event.keyCode===219 && event.metaKey) ) { //Unindent
			this.props.unindent();
			this.setState({indent: Math.max(0,this.state.indent - 1)})
			event.preventDefault();
		} else if (event.keyCode===1 && event.metaKey) {

		
		} else if ( event.keyCode===38 && event.metaKey && event.shiftKey) { // Collapse Upward
			this.props.collapseUpward();	

		} else if ( event.keyCode===38 && event.metaKey ) { // Collapse
			this.props.collapse();

		

		} else if ( event.keyCode===40 && event.metaKey ) { // Expand
			this.props.expand();

		} else if ( event.keyCode===38 && event.metaKey ) { // Jump To / Search

		} else if (event.keyCode ===38 ) { //Up Arrow
			this.props.moveFocusUp();

		} else if (event.keyCode === 40) { //Down Arrow
			this.props.moveFocusDown();

		

		} else if (event.keyCode===13) { //Return key
			let s = event.target.value;
			let find = '\n';
			let hacker = [];
			let i = 0;
			while (~(i = s.indexOf (find,i + find.length))) hacker.push(i);
			let oldValue = event.target.value.substr(0,event.target.selectionEnd);
			let newValue = event.target.value.substr(event.target.selectionEnd,9999);
			//TODO:  Need to update this to make sure when cursor is at 0 and pressing enter, 
			//you don't lose the obj data (e.g., task, collapse)
			let newObj = {...this.props.obj, t: oldValue, expand: true};
			this.textarea.current.setRangeText("",event.target.selectionEnd,9999)
			this.setState({text: oldValue});
			this.props.updateObj(this.props.obj.id, newObj)
			this.props.insert(newValue, this.props.obj.id);
			event.preventDefault();
		} else if (event.keyCode===8) { //Backspace key
			
			// delete if no kids and no more text in state
			if (event.target.value === '') {
				this.props.delete();
				event.preventDefault();
			}

		} else if (event.keyCode===73 && event.metaKey) {
			this.props.addTask();
		}
		
		
		if (event.keyCode !== 38 && event.keyCode !== 40 ) {
			if (event.keyCode !== 13 && event.keyCode !== 8) {
				this.props.setFocus(this.props.obj.id, this.state.focus, this.textarea.current.selectionStart, this.textarea.current.selectionEnd);
			}
			
		}
		//Capture backspace when text = '' to delete element
		//Save state (text and cursor position) every 1 second, save last 50?
	}

	handleKeyUp(event) {

	}


	handleZoomClick(event) {
		this.props.setZoomObjId();
	}

	showOptions(show) {
		// console.log('1')
		this.setState({showOptions: show})
	}

	handleTaskClick(event) {
		//create task with due date
		this.setState({showTaskOptions: true});
	}

	handleAddTask(event) {
		this.props.addTask(this.state.date);
	}

	handleOutsideClick() {
		this.setState({showTaskOptions: false});
	}

	handleDateChange(date) {
		this.props.addTask(this.props.obj.id, date.toDate());
		this.setState({showTaskOptions: false});
	}

	handleMenuClick({event, props}) { 
		console.log(event,props) 
	}

	handleOptionsMenuClick(e){
	    e.preventDefault();
	    contextMenu.show({
	      id: 'menu_id' + this.props.obj.id,
	      event: e,
	    });
	    
	  }

	render() {
			return 	<div className="ElementContainer" key={"ElementContainer_"+this.props.obj.id}  >
			<div className="ElementOptionsContainer" onMouseLeave={this.showOptions.bind(this, false)} style={this.state.showOptions ? {backgroundColor: 'rgba(0,0,0,0.05)'} : null }>

				<div className="OptionButton" >
					{ this.state.showOptions ? 
						<Tooltip title="Options" placement="top"><img className="TaskButton"  alt="" src={ellipsis} onClick={this.handleOptionsMenuClick} /></Tooltip>   
		        		: 
		        		null 
		        	}
		        </div>
				<div className="OptionButton" >{ this.state.showOptions ? <Tooltip title="Zoom In" placement="top"><img className="ZoomButton" alt="" src={zoom} onClick={this.handleZoomClick.bind(this)} onMouseOver={this.showOptions.bind(this)} /></Tooltip> : null } </div>
				<div className="OptionButton" onMouseOver={this.showOptions.bind(this, true)}>
					{ this.props.obj.kids.length === 0 ? 
						'complete' in this.props.obj && this.props.obj.complete ? <img className="Bullet" alt="" src={diamondGreen}/>  : <img className="Bullet Diamond" alt="" src={diamond}/> 
						: 
						(this.props.obj.expand ? 
								<img className="Bullet Arrow" alt="" src={'complete' in this.props.obj && this.props.obj.complete ? downArrowGreen : downArrow} onClick={this.handleBoxClick} />
								: 
								<img className="Bullet Arrow" alt="" src={'complete' in this.props.obj && this.props.obj.complete ? rightArrowGreen : rightArrow} onClick={this.handleBoxClick}/> 
						)  
					}  
				</div>
				
 
			</div>
				<div className="BoxContainer" key={"BoxContainer_" + this.props.obj.id}  >
					
		        <Menu id={'menu_id'+this.props.obj.id}>
			       {"due" in this.props.obj ? (!this.props.obj.complete ? <Item onClick={this.props.removeTask}>Remove from Tasks</Item> : null) : <Item onClick={this.handleTaskClick}>Add to Tasks</Item>}
			       {"complete" in this.props.obj && this.props.obj.complete ? <Item onClick={this.props.toggleComplete}>Mark as incomplete</Item> : <Item onClick={this.props.toggleComplete}>Mark as complete</Item>}
			       <Separator />
			       <Item onClick={this.props.indent}>Indent</Item>
			       <Item onClick={this.props.unindent}>Unindent</Item>
			       <Item disabled>Expand All</Item>
			       <Item disabled>Collapse All</Item>
		          </Menu>
				</div>


				<div className="ElementTextAreaContainer" key={"ElementTextAreaContainer_" + this.props.obj.id}>
					<textarea className="Element" onChange={this.handleChange} onFocus={this.onFocus} onBlur={this.onBlur} rows={1} onKeyDown={this.handleKeyDown} onKeyUp={this.handleKeyUp} defaultValue={this.state.text} key={"ElementTextArea_" + this.props.obj.id} ref={this.textarea} ></textarea>


					<p className="Element Clone">{this.state.text}</p>
				</div>

				{ this.state.showTaskOptions ? 
					<div className="TaskOptionsBackground" onClick={this.handleOutsideClick.bind(this)}>
						
					</div> 
					: null}
					{ this.state.showTaskOptions ? 
						<div className="CreateTaskOptions">
							<Datetime input={false} timeFormat={false} onChange={this.handleDateChange.bind(this)}/>
						</div>
						: null }
			</div>;
	}

}

export default Element;